import { z } from 'zod';
import { JobStatusSchema } from '@/features/jobs/schemas';

const ActivityRowSchema = z.object({
  id: z.string(),
  title: z.string(),
  status: JobStatusSchema,
  error_message: z.string().nullable(),
  assigned_member_id: z.string().nullable(),
  created_by_tenant_user_id: z.string().nullable(),
  created_at: z.string(),
  started_at: z.string().nullable(),
  completed_at: z.string().nullable(),
  cancelled_at: z.string().nullable(),
  created_from_template_id: z.string().nullable(),
  template_title: z.string().nullable(),
  template_icon: z.string().nullable(),
  template_status: z.string().nullable(),
  member_first_name: z.string().nullable(),
  member_last_name: z.string().nullable(),
  submitter_first_name: z.string().nullable(),
  submitter_last_name: z.string().nullable(),
  is_unread: z.boolean(),
});
export type ActivityRow = z.infer<typeof ActivityRowSchema>;

export const ActivityInboxResponseSchema = z.object({
  scope: z.enum(['mine', 'team']),
  window: z.enum(['48h', '7d', '30d', 'all']),
  activity_last_seen_at: z.string().nullable(),
  sections: z.object({
    needs_attention: z.array(ActivityRowSchema),
    active: z.array(ActivityRowSchema),
    recently_completed: z.array(ActivityRowSchema),
    older_history: z.array(ActivityRowSchema),
  }),
});
export type ActivityInboxResponse = z.infer<typeof ActivityInboxResponseSchema>;

export const LastSeenResponseSchema = z.object({
  activity_last_seen_at: z.string().nullable(),
});
export type LastSeenResponse = z.infer<typeof LastSeenResponseSchema>;
